<template>
  <div class="page container">
    <rebuild-nav-bar></rebuild-nav-bar>
    <div class="filter-bar" ref="filterBar">
      <div class="search-wrapper" :class="isSearch?'active':''">
        <img src="~@static/ugc/list/search-bg-default.png" class="input-bg default-bg">
        <img src="~@static/ugc/list/search-bg.png" class="input-bg active-bg">
        <input class="form-control" maxlength="20" placeholder="搜索想查找的夜计划" @focus="bindSearchTap" @blur="bindSearchBlur" @change="bindSearchChange" placeholder-class="placeholder-style" />
      </div>
      <div class="sort-wrapper" @click="bindToSort">
        <img src="~@static/ugc/list/icon-sort.png" v-if="!isSort">
        <img src="~@static/ugc/list/icon-sort-on.png" v-if="isSort">
      </div>
      <div class="filter-wrapper" @click="bindToFilter">
        <img src="~@static/ugc/list/icon-filter.png" v-if="!isFilter">
        <img src="~@static/ugc/list/icon-filter-on.png" v-if="isFilter">
      </div>
    </div>
    <!--  -->
    <div class="container-water-fall galleries-list">
      <waterfall :col='col' :data="data" @loadmore="loadmore" @scroll="scroll" :height="waterfall_h">
        <template>
          <div class="cell-item gallery-item" v-for="(item,index) in data" :key="index">
            <div class="gallery-cover" @click="bindToDetail" :data-id="item.id" :data-name="item.title">
              <template v-if="!item.filter_id || item.filter_id[0]==0">
                <img :src="hostUrl + item.picture" class="cover-img" mode="widthFix">
              </template>
              <template v-else>
                <img :src="hostUrl + item.picture" class="cover-img" mode="widthFix">
                <img :src="require(`@static/ugc/creation/filter/mask-${item.filter_id[0]}.png`)" class="filter-mask">
                <img :src="require(`@static/ugc/creation/filter/top-${item.filter_id[0]}.png`)" class="filter-top">
                <img :src="require(`@static/ugc/creation/filter/bottom-${item.filter_id[0]}.png`)" class="filter-bottom">
              </template>
            </div>
            <div class="gallery-content-wrapper">
              <div class="plan-title-wrapper">
                <div class="tit"><div class="inner">{{item.name}}</div></div>
                <div class="location-wrapper" v-if="item.distance>0">
                  <img mode="widthFix" src="~@static/ugc/list/icon-spot.png">{{(item.distance / 1000).toFixed(1)}}KM
                </div>
              </div>
              <div class="gallery-title" :data-id="item.id" :data-name="item.title">{{item.title}}</div>
              <div class="item-wrapper">
                <div class="user-wrapper">
                  <img :src="item.headimgurl==''? require('@static/fundingnew/register/avatar-default.png') : item.headimgurl">
                  {{item.nickname}}
                </div>
                <div class="like-wrapper">
                  <div class="text">{{item.like_count}}</div>
                  <button class="button operation-item" v-if="noLogin" @click="toLogin">
                    <div class="btn-inner">
                      <img src="~@static/ugc/list/icon-un-like.png" />
                    </div>
                  </button>

                  <button v-else class="button operation-item" @click="bindLiked(item.id, index)">
                    <div class="btn-inner">
                      <img v-if="item.voted == '1'" src="~@static/ugc/list/icon-like.png" mode="widthFix" />
                      <img v-if="item.voted != '1'" src="~@static/ugc/list/icon-un-like.png" mode="widthFix" />
                    </div>
                  </button>
                </div>
              </div>

            </div>
          </div>
        </template>
      </waterfall>
      <!-- <loading :show="loading" /> -->
    </div>

    <div class="scroll-top-btn" @click="scrollToTop">
      <img class="icon-top" src="~@static/funding/icon-top.png">
    </div>
    <div class="pop-award" v-if="isShowAward">
      <div class="pop-inner">
        <div class="text" v-html="`上传照片<br>点赞数排名前十名将获得神秘福利`"></div>
        <div class="btn-submit" @click="bindToClose">知道啦</div>
      </div>
    </div>
    <img class="btn-add" src="~@static/ugc/list/btn-add.png" @click="bindToCreate">

    <div class="pop-sort" v-if="isSort">
      <div class="pop-title">请选择排序方式</div>
      <div class="pop-wrapper">
        <div class="pop-content">
          <div :class="sortType==1?'cur':''" @click="bindToChangeSort" data-type="1">最新</div>
          <div :class="sortType==2?'cur':''" @click="bindToChangeSort" data-type="2">离我最近</div>
          <div :class="sortType==3?'cur':''" @click="bindToChangeSort" data-type="3">点赞最多</div>
        </div>
      </div>
    </div>

    <!-- pop -->
    <div class="mask" v-if="isFilter" @click="isFilter=false"></div>
    <div class="pop-filter" v-if="isFilter">
      <div class="pop-title">请选择要查找的夜计划</div>
      <div class="pop-wrapper">
        <div class="pop-content">
          <div :class="planId==item.id?'cur':''" @click.stop="bindToChangeFilter" :data-id="item.id" :data-name="item.name" v-for="(item, index) in plans" :key="index">{{item.name}}</div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import PageFooter from '@components/PageFooter'
import RebuildNavBar from '@components/RebuildNavBar'
import { mapState } from 'vuex'
import { storage, verify, tools } from '@/utils'
import { behavior } from '@/utils/behavior'
const geolocation = new qq.maps.Geolocation()
export default {
  data() {
    return {
      hostUrl: this.$apiConfig.host,
      isSearch: false,
      isSort: false,
      isFilter: false,
      filterParam: {
        page: 1,
        per_page: 12,
        name: '',
        plan_id: 0,
        lat: 0,
        lng: 0,
      },

      data: [],
      col: 2,
      loading: false,
      isFinish: false,
      planId: 0,
      waterfall_h: '0px',
      isShowAward: false,
      plans: [],
    }
  },
  components: {
    PageFooter,
    RebuildNavBar,
  },
  computed: {
    itemWidth() {
      return 138 * 0.5 * (document.documentElement.clientWidth / 375)
    },
    gutterWidth() {
      return 9 * 0.5 * (document.documentElement.clientWidth / 375)
    },
    ...mapState(['authorization']),
    noLogin() {
      return !this.authorization || this.authorization == ''
    },
  },
  created() {
    let pos = {}
    let ugcVisitCount = storage.getLocalData('ugcVisitCount') || 0
    if (ugcVisitCount < 3) {
      storage.setLocalData('ugcVisitCount', Number(ugcVisitCount) + 1, 604700)
      this.isShowAward = true
    } else {
      this.isShowAward = false
    }
    setTimeout(() => {
      this.bindToClose()
    }, 4000)

    this.requestPlans()
    geolocation.getLocation(
      pos => {
        this.filterParam.lat = pos.lat
        this.filterParam.lng = pos.lng
        //
        this.requestGalleries()
      },
      fail => {
        this.requestGalleries()
        if (fail.code === 1) {
          console.log('拒绝定位权限')
        }
      },
    )
  },
  mounted() {
    var self = this
    let h1 = this.$refs.filterBar.clientHeight
    let h2 = document.documentElement.clientHeight
    this.waterfall_h = Number(h2 - h1 - 60) + 'px'

    if (verify.isWeixin()) {
      let shareInfo = {
        title: '绝对夜计划',
        desc: '绝对赛博夜计划，最高赢取5万元派对金，邀你一起造',
        imgUrl: this.$apiConfig.domain + '/static/funding_cpunk/share.png?v=1',
      }
      let p = tools.parseParams(this.$route.query)
      this.WXConfig.wxShowMenu(`${this.$apiConfig.domain}/welcome?${p}`, shareInfo)
    }
  },
  methods: {
    bindToClose() {
      this.isShowAward = false
    },
    requestGalleries: function () {
      const _self = this
      this.$request
        .get(this.$apiConfig.ugcUrl, { params: this.filterParam })
        .then(res => {
          const resData = res.data
          if (resData.code == 0 && resData.data) {
            const { totalCount, pageCount, currentPage } = resData.data._meta
            if (pageCount === currentPage) {
              this.isFinish = true
            } else {
              this.filterParam.page += 1
            }

            if (pageCount === 0) {
              this.isFinish = false
              this.filterParam.page = 1
            }

            this.data = this.data.concat(resData.data.items)
          } else {
            console.log(res.msg)
          }
          this.loading = false
        })
        .catch(e => {
          console.log(e)
        })
    },
    requestPlans: function () {
      const _self = this
      this.$request
        .get(this.$apiConfig.ugcPlanUrl)
        .then(res => {
          const resData = res.data
          if (resData.code === 0) {
            this.plans = resData.data
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    bindSearchTap() {
      this.isSearch = true
    },
    bindSearchChange(e) {
      let filterParam = this.filterParam
      filterParam.name = e.target.value
      filterParam.page = 1
      this.filterParam = filterParam
      this.data = []
      this.isFinish = false
      this.requestGalleries()
    },
    bindSearchBlur() {
      this.isSearch = false
    },
    bindToSort(e) {
      this.isSort = !this.isSort
      this.isFilter = false
      _jcq.push(['_track', 'ugc_sortselect'])
      behavior({ behavior_code: 'prc_bhv_abs_pw_bc4' })
    },
    scroll(data) {
      // console.log(data)
    },

    loadmore(num) {
      if (this.loading || this.isFinish) {
        return
      }
      this.loading = true
      this.requestGalleries()
    },
    scrollToTop: function (e) {
      document.querySelector('#vueWaterfall').scrollTop = 0
    },

    bindToCreate: function (e) {
      this.$router.push('/scene/intro')
      _jcq.push(['_track', 'ugc_uploadclick'])
      behavior({ behavior_code: 'prc_bhv_abs_pw_bc3' })
    },
    bindToDetail(e) {
      let { id, name } = e.target.dataset
      _jcq.push(['_track', 'ugc_campaignclick', { campaign: name }])
      behavior({ behavior_code: 'prc_bhv_abs_pw_bc1', name: name })
      this.$router.push(`/scene/detail/${id}`)
    },
    //
    bindToFilter() {
      this.isFilter = !this.isFilter
      this.isSort = false
      _jcq.push(['_track', 'ugc_campaignselect'])
      behavior({ behavior_code: 'prc_bhv_abs_pw_bc2' })
    },
    bindToChangeFilter(e) {
      let plan_id = e.target.dataset.id
      if (plan_id == this.planId) {
        this.planId = 0
        plan_id = 0
      }
      let filterParam = this.filterParam
      filterParam.plan_id = plan_id
      filterParam.page = 1

      this.filterParam = filterParam
      this.planId = plan_id
      this.isFilter = false
      this.data = []
      this.isFinish = false
      this.requestGalleries()
    },

    bindToChangeSort(e) {
      let filterParam = this.filterParam
      let type = e.target.dataset.type
      filterParam.order_type = type
      filterParam.page = 1
      this.filterParam = filterParam
      this.sortType = type
      this.isSort = false
      this.data = []
      this.isFinish = false
      this.requestGalleries()
    },
    toLogin() {
      this.$router.push(`/login?redirect=${encodeURIComponent(this.$route.fullPath)}`)
    },
    bindLiked(id, index) {
      _jcq.push(['_track', 'ugc_like'])
      behavior({ behavior_code: 'prc_bhv_abs_pw_bc6' })

      this.$request.post(this.$apiConfig.ugcVoteUrl + '/' + id).then(res => {
        let resData = res.data
        let _resData = resData.data
        if (resData.code == 0) {
          alert('您已成功投票')
          this.data[index].voted = '1'
          let n = parseInt(this.data[index].like_count)
          this.data[index].like_count = n + 1
        } else if (resData.code == 602) {
          alert('同一活动只能投票3次')
        } else {
          alert('投票失败')
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@styles/ugc/list.scss';
</style>

<style>
.vue-waterfall-column:nth-of-type(2) {
  padding-right: 0.66666666666vw;
}

.vue-waterfall-column:nth-of-type(3) {
  padding-left: 0.66666666666vw;
}
</style>



// WEBPACK FOOTER //
// src/pages/ugc/list.vue